import type { FC } from 'react';
import { Fragment } from 'react';
import { SectionSubtitle, SectionText } from '..';
import * as Styled from './styled';
import type { ProLandingSectionContentProps } from './types';

export const ProLandingSectionContent: FC<ProLandingSectionContentProps> = (props) => {
  const {
    title,
    subtitle,
    contents = [],
    image,
    imageOnLeft = false,
    children,
    titleColor = 'blue',
    subtitleColor = 'blue',
    ...rest
  } = props;

  return (
    <Styled.StyledContainer {...rest}>
      <Styled.ContentWrapper>
        <Styled.Title dangerouslySetInnerHTML={{ __html: title }} color={titleColor} />
        {subtitle && <SectionSubtitle dangerouslySetInnerHTML={{ __html: subtitle }} />}
        {contents.map((content, index) => (
          <Fragment key={index}>
            <Styled.Subtitle
              color={subtitleColor}
              dangerouslySetInnerHTML={{ __html: content.subtitle }}
            />
            <SectionText dangerouslySetInnerHTML={{ __html: content.text }} />
          </Fragment>
        ))}
        <Styled.ChildrenWrapper>{children}</Styled.ChildrenWrapper>
      </Styled.ContentWrapper>
      <Styled.Image src={image} imageOnLeft={imageOnLeft} />
    </Styled.StyledContainer>
  );
};
